import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dataNullDefault",
  standalone: true,
})
export class DataNullDefaultPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value === undefined || value === null || value.trim() === "") {
      return "-";
    }
    return value;
  }
}
